let routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/gxqgouche2212/pages/Home.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  },
  {
    path: '/add-car',
    name: 'Home',
    component: () => import('@/views/gxqgouche2212/pages/AddCar.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  },
  {
    path: '/record-list',
    name: 'RecordList',
    component: () => import('@/views/gxqgouche2212/pages/RecordList.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/gxqgouche2212/pages/Download.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/gxqgouche2212/pages/Login.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  },
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/views/gxqgouche2212/pages/404.vue'),
    meta: {
      title: '枫购跨年狂欢季'
    }
  }
]

routes = [...routes]

export default routes
